import React, { useState, useEffect } from "react";
import classes from "./ContactsSection.module.css";
import emailjs from "emailjs-com";
import Aos from "aos";
import "aos/dist/aos.css";

const ContactSection = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  const [enteredEmail, setEnteredEmail] = useState("");
  const [emailIsValid, setEmailIsValid] = useState();
  // const [message, setMessage] = useState();
  // const [formIsValid, setFormIsValid] = useState(false);

  const emailChangeHandler = (event) => {
    setEnteredEmail(event.target.value);
  };
  const validateEmailHandler = () => {
    setEmailIsValid(enteredEmail.includes("@"));
  };

  const submitHandler = (event) => {
    event.preventDefault();
    emailjs.init("NaOfwGn7-Y1sEYTCg");
    emailjs.sendForm("service_m1e4hla", "template_g7zpzq8", event.target).then(
      function (response) {
        console.log("SUCCESS!", response.status, response.text);
      },
      function (error) {
        console.log("FAILED...", error);
      }
    );
    event.target.reset();
  };

  return (
    <>
      <div data-aos="fade-down" className={classes.login}>
        <form onSubmit={submitHandler}>
          <div className={classes.control}>
            <label>Name:</label>
            <input type="text" id="fname" name="name" />
          </div>
          <div
            className={`${classes.control} ${
              emailIsValid === false ? classes.invalid : ""
            }`}
          >
            <label>E-Mail:</label>
            <input
              type="text"
              id="email"
              name="user_email"
              value={enteredEmail}
              onChange={emailChangeHandler}
            />
          </div>
          <div className={classes.control}>
            <label>Message:</label>
            <textarea id="w3review" name="message" rows="8" cols="60">
              Message...
            </textarea>
          </div>

          <div className={classes.actions}>
            <button
              type="submit"
              className={classes.btn}
              onClick={validateEmailHandler}
            >
              Connect
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactSection;
